import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { createReason, deleteReason, fetchReason } from './api';
import { CreateReasonFormData } from './types';

export const useReasonQuery = (
  token: string | undefined,
  reasonId: string | undefined
) =>
  useQuery(['reason', token, reasonId], () => fetchReason(token, reasonId), {
    enabled: !!(token && reasonId)
  });

export const useCreateReasonMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    ['createReason', token],
    (formData: CreateReasonFormData) => createReason(token, formData),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['weekDetails']);
      }
    }
  );
};

export const useDeleteReasonMutation = (refId: string | undefined) => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    ['deleteReason', token, refId],
    () => deleteReason(token, refId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['weekDetails']);
      }
    }
  );
};
